export const OPEN_SECTIONS_INDEX = 'OPEN_SECTIONS_INDEX'
export const CLOSE_SECTIONS_INDEX = 'CLOSE_SECTIONS_INDEX'

export function openSectionsIndex(payload) {
  return {
    payload: {
      ...payload,
      isOpen: true,
    },
    type: OPEN_SECTIONS_INDEX,
  }
}

export function closeSectionsIndex(payload) {
  return {
    payload: {
      ...payload,
      isOpen: false,
    },
    type: CLOSE_SECTIONS_INDEX,
  }
}
